module.exports = __webpack_public_path__ + "img/lenovo_x1yoga.d998ea66.png";